/**
 * @Name：admin api模块
 * @Author：syy
 * @description：本文件中编写通用接口，各页面具体接口请在 src/api 中建立文件夹，如：src/api/Author.js 是用户模块使用的api
 */
import request from "@/request";
/* 图形验证码 */
export function getLoginVerifyt(data) {
  return request({
    url : '/merchant/Login/verify',
    method : "post",
    data
  });
}
/* 登录 */
export function getLogin(data) {
  return request({
    url : '/merchant/Login/login',
    method : "post",
    data
  });
}
/* 地址管理 */
export function getaddressList(data) {
  return request({
    url : '/merchant/Housing/address_list',
    method : "post",
    data
  });
}
/* 新增-地址 */
export function getaddressUpdate(data) {
  return request({
    url : '/merchant/Housing/address_update',
    method : "post",
    data
  });
}
/* 编辑回显-地址 */
export function getaddressEditDefault(data) {
  return request({
    url : '/merchant/Housing/address_edit',
    method : "post",
    data
  });
}
/* 编辑回显-删除 */
export function getaddressDel(data) {
  return request({
    url : '/merchant/Housing/address_del',
    method : "post",
    data
  });
}

/* 房型列表 */
export function getFacilityservices(data) {
  return request({
    url : '/merchant/Housing/facilityservices',
    method : "post",
    data
  });
}
/* 房型列表--删除 */
export function getFacilityservicesDel(data) {
  return request({
    url : '/merchant/Housing/facilityservices_del',
    method : "post",
    data
  });
}
/* 房型列表--基础信息 */
export function getFacilityservicesInfo(data) {
  return request({
    url : '/merchant/Housing/facilityservices_add',
    method : "post",
    data
  });
}
/* 房型列表--新增*/
export function getFacilityservicesUpdate(data) {
  return request({
    url : '/merchant/Housing/facilityservices_update',
    method : "post",
    data
  });
}
/* 房型列表--编辑回显*/
export function getFacilityservicesEdit(data) {
  return request({
    url : '/merchant/Housing/facilityservices_edit',
    method : "post",
    data
  });
}

/* 房源列表 */
export function gethousingList(data) {
  return request({
    url : '/merchant/Housing/housing_list',
    method : "post",
    data
  });
}
/* 房源列表 -- 修改回显 */
export function gethousingEdit(data) {
  return request({
    url : '/merchant/Housing/housing_edit',
    method : "post",
    data
  });
}
/* 房源列表 -- 新增 */
export function gethousingUpdate(data) {
  return request({
    url : '/merchant/Housing/housing_update',
    method : "post",
    data
  });
}
/* 房源列表 -- 删除 */
export function gethousingdel(data) {
  return request({
    url : '/merchant/Housing/housing_del',
    method : "post",
    data
  });
}
/* 房源列表 -- 获取新增编辑下拉数据 */
export function gethousingAdd(data) {
  return request({
    url : '/merchant/Housing/housing_add',
    method : "post",
    data
  });
}
/* 房价列表 -- 列表 */
export function getdaily_prices(data) {
  return request({
    url : '/merchant/Housing/daily_prices',
    method : "post",
    data
  });
}
/* 房价列表 -- 单个日期改价 */
export function getsingleday_price(data) {
  return request({
    url : '/merchant/Housing/singleday_price',
    method : "post",
    data
  });
}
/* 房价列表 -- 批量改价下拉数据 */
export function getbatch_priceadd(data) {
  return request({
    url : '/merchant/Housing/batch_priceadd',
    method : "post",
    data
  });
}
/* 房价列表 -- 批量改价提交 */
export function getbatch_price(data) {
  return request({
    url : '/merchant/Housing/batch_price',
    method : "post",
    data
  });
}
/* 实时房态 -- 列表 */
export function getrealtime_room(data) {
  return request({
    url : '/merchant/Housing/realtime_room',
    method : "post",
    data
  });
}
/* 实时房态 -- 状态操作 */
export function getroomtype_operation(data) {
  return request({
    url : '/merchant/Housing/roomtype_operation',
    method : "post",
    data
  });
}
/* 远期房态 -- 列表 */
export function getlongterm_housing(data) {
  return request({
    url : '/merchant/Housing/longterm_housing',
    method : "post",
    data
  });
}


/* 管理员列表 */
export function getmanageList(data) {
  return request({
    url : '/merchant/Member/manage_list',
    method : "post",
    data
  });
}
/* 管理员列表 -- 回显 */
export function getmanageListedit(data) {
  return request({
    url : '/merchant/Member/manage_edit',
    method : "post",
    data
  });
}
/* 管理员列表 -- 新增 */
export function getmanageListUpdate(data) {
  return request({
    url : '/merchant/Member/manage_update',
    method : "post",
    data
  });
}
/* 管理员列表 -- 权限下拉 */
export function getmanageListAdd(data) {
  return request({
    url : '/merchant/Member/manage_add',
    method : "post",
    data
  });
}

/* 管理员列表 -- 个人信息 */
export function getMemberAccount(data) {
  return request({
    url : '/merchant/Member/account',
    method : "post",
    data
  });
}

/* 管理员列表 -- 企业信息提交 */
export function getMemberUpdateInfo(data) {
  return request({
    url : '/merchant/Member/update_info',
    method : "post",
    data
  });
}
/* 管理员列表 -- 企业信息回显 */
export function getMemberInfo(data) {
  return request({
    url : '/merchant/Member/info',
    method : "post",
    data
  });
}
/* 管理员列表 -- 企业信息搜索关键词 */
export function getget_search(data) {
  return request({
    url : '/merchant/Member/get_search',
    method : "post",
    data
  });
}

/* 订单列表 */
export function getorderList(data) {
  return request({
    url : '/merchant/Order/order_list',
    method : "post",
    data
  });
}
/* 订单列表 --新增 */
export function getorderorderUpdate(data) {
  return request({
    url : '/merchant/Order/order_update',
    method : "post",
    data
  });
}

/* 订单列表 --必要信息 */
export function getorderorderAdd(data) {
  return request({
    url : '/merchant/Order/order_add',
    method : "post",
    data
  });
}

/* 订单列表 --编辑 */
export function getorderorderEdit(data) {
  return request({
    url : '/merchant/Order/order_edit',
    method : "post",
    data
  });
}

/* 订单列表 --取消订单 */
export function getcancellationOrder(data) {
  return request({
    url : '/merchant/Order/cancellation_order',
    method : "post",
    data
  });
}

/* 订单列表 --退房 */
export function getOrderCheck_out(data) {
  return request({
    url : '/merchant/Order/check_out',
    method : "post",
    data
  });
}

/* 订单列表 -- 绑定房间 --房间下拉 */
export function getbindRoom(data) {
  return request({
    url : '/merchant/Order/bind_room',
    method : "post",
    data
  });
}
/* 订单列表 -- 绑定房间 */
export function getbindRoomupdate(data) {
  return request({
    url : '/merchant/Order/bind_roomupdate',
    method : "post",
    data
  });
}

/* 订单列表 -- 回显 */
export function getbindRoomeditroom(data) {
  return request({
    url : '/merchant/Order/bind_editroom',
    method : "post",
    data
  });
}

/* 入驻登记列表 */
export function getcheckinList(data) {
  return request({
    url : '/merchant/Order/checkin_list',
    method : "post",
    data
  });
}

/* 办理入住 */
export function getcheckin(data) {
  return request({
    url : '/merchant/Order/check_in',
    method : "post",
    data
  });
}

/* 入驻登记列表 -- 删除 */
export function getOrderCheckDel(data) {
  return request({
    url : '/merchant/Order/check_del',
    method : "post",
    data
  });
}

/* 按钮权限 */
export function getOrderuserRule(data) {
  return request({
    url : '/merchant/Member/user_rule',
    method : "post",
    data
  });
}

/* 左侧导航 */
export function getMembermodellist(data) {
  return request({
    url : '/merchant/Member/model_list',
    method : "post",
    data
  });
}

/* 修改密码 */
export function getMemberupdatepwd(data) {
  return request({
    url : '/merchant/Member/update_pwd',
    method : "post",
    data
  });
}
/* 地址搜索关键词 */
export function getSearch(data) {
  return request({
    url : '/merchant/Housing/get_search',
    method : "post",
    data
  });
}

/* 订单管理-订单列表 */
export function getorder_list(data) {
  return request({
    url : '/merchant/Order/order_list',
    method : "post",
    data
  });
}
/* 订单管理-选择房间 */
export function getcheckin_roomtype(data) {
  return request({
    url : '/merchant/Order/checkin_roomtype',
    method : "post",
    data
  });
}
/* 订单管理-添加入住提交 */
export function getorderadd_checkin(data) {
  return request({
    url : '/merchant/Order/add_checkin',
    method : "post",
    data
  });
}
/* 订单管理-添加预订提交 */
export function getorderadd_reserve(data) {
  return request({
    url : '/merchant/Order/add_reserve',
    method : "post",
    data
  });
}
/* 订单管理-订单详情 */
export function getorder_info(data) {
  return request({
    url : '/merchant/Order/order_info',
    method : "post",
    data
  });
}
/* 订单管理-订单详情修改信息 */
export function getorder_updatecontacts(data) {
  return request({
    url : '/merchant/Order/order_updatecontacts',
    method : "post",
    data
  });
}
/* 订单管理-订单详情修改订单金额、押金 */
export function getorder_updatetotalprice(data) {
  return request({
    url : '/merchant/Order/order_updatetotalprice',
    method : "post",
    data
  });
}
/* 订单管理-订单详情入住人信息 */
export function getorder_checkin(data) {
  return request({
    url : '/merchant/Order/order_checkin',
    method : "post",
    data
  });
}
/* 订单管理-订单详情入住人信息删除 */
export function getorder_check_del(data) {
  return request({
    url : '/merchant/Order/check_del',
    method : "post",
    data
  });
}
/* 订单管理-订单详情入住人信息删除 */
export function getorder_updatecheckin(data) {
  return request({
    url : '/merchant/Order/order_updatecheckin',
    method : "post",
    data
  });
}
/* 订单管理-订单入住信息回显 */
export function getorderbooking_checkin(data) {
  return request({
    url : '/merchant/Order/booking_checkin',
    method : "post",
    data
  });
}
/* 订单管理-订单入住信息提交 */
export function getordercheckin_processing(data) {
  return request({
    url : '/merchant/Order/checkin_processing',
    method : "post",
    data
  });
}
/* 订单管理-订单换房信息回显 */
export function getorderexchange_houses(data) {
  return request({
    url : '/merchant/Order/exchange_houses',
    method : "post",
    data
  });
}
/* 订单管理-订单换房选择房间 */
export function getorderexchange_housestype(data) {
  return request({
    url : '/merchant/Order/exchange_housestype',
    method : "post",
    data
  });
}
/* 订单管理-订单换房选择房间 */
export function getorderexconfirmorder_housestype(data) {
  return request({
    url : '/merchant/Order/confirmorder_housestype',
    method : "post",
    data
  });
}
/* 订单管理-订单换房提交处理 */
export function getexchange_updatgehousestype(data) {
  return request({
    url : '/merchant/Order/exchange_updatgehousestype',
    method : "post",
    data
  });
}
/* 订单管理-订单离店详情回显 */ 
export function getordercheck_outinfo(data) {
  return request({
    url : '/merchant/Order/check_outinfo',
    method : "post",
    data
  });
}
/* 订单管理-订单离店处理 */ 
export function getordercheck_out(data) {
  return request({
    url : '/merchant/Order/check_out',
    method : "post",
    data
  });
}
/* 订单管理-订单续住接口 */ 
export function getorderrenewal_lease(data) {
  return request({
    url : '/merchant/Order/renewal_lease',
    method : "post",
    data
  });
}
/* 订单管理-确认订单回显 */ 
export function getconfirm_order(data) {
  return request({
    url : '/merchant/Order/confirm_order',
    method : "post",
    data
  });
}
/* 订单管理-确认订单回显 */ 
export function getconfirm_updateorder(data) {
  return request({
    url : '/merchant/Order/confirm_updateorder',
    method : "post",
    data
  });
}
/* 订单管理-取消订单回显 */ 
export function getreason_type(data) {
  return request({
    url : '/merchant/Order/reason_type',
    method : "post",
    data
  });
}

/* 订单管理-取消订单提交 */ 
export function getcancellation_order(data) {
  return request({
    url : '/merchant/Order/cancellation_order',
    method : "post",
    data
  });
}

/* 预警列表 */ 
export function getHousingwarning(data) {
  return request({
    url : '/merchant/Housing/warning',
    method : "post",
    data
  });
}
/* 预警列表 */ 
export function get_organizations(data) {
  return request({
    url : '/merchant/Member/get_organizations',
    method : "post",
    data
  });
}
/* 下拉数据 */ 
export function get_service(data) {
  return request({
    url : '/merchant/Member/get_service',
    method : "post",
    data
  });
}
/* 设备管理列表 */ 
export function getequipment(data) {
  return request({
    url : '/merchant/Member/equipment',
    method : "post",
    data
  });
}
/* 设备管理删除 */ 
export function getequipment_del(data) {
  return request({
    url : '/merchant/Member/equipment_del',
    method : "post",
    data
  });
}
/* 设备管理详情 */ 
export function getequipment_edit(data) {
  return request({
    url : '/merchant/Member/equipment_edit',
    method : "post",
    data
  });
}
/* 设备管理添加修改 */ 
export function getequipment_update(data) {
  return request({
    url : '/merchant/Member/equipment_update',
    method : "post",
    data
  });
}
/* 更新二维码 */ 
export function getupdate_erweima(data) {
  return request({
    url : '/merchant/Housing/update_erweima',
    method : "post",
    data
  });
}
/* 获取二维码信息 */ 
export function get_templateinfo(data) {
  return request({
    url : '/merchant/Housing/get_templateinfo',
    method : "post",
    data
  });
}
